import type { LicensedTerritory } from '@lottocom/lottery-mapping'
import type { Money as PriceLibMoney } from '@lottocom/price-calculation'

import Money from '~~/models/Money'

type Price = {
  chargeTotal: PriceLibMoney
  grossTotal: PriceLibMoney
}

export const usePriceBreakdownHeader = (
  price: MaybeRef<Maybe<Price>>,
  withFlyOut: MaybeRef<Maybe<boolean>>,
) => {
  const licensedTerritory = useLicensedTerritory({ raw: true })
  const isPriceTransparencyEnabled = useIsPriceTransparencyEnabled(
    licensedTerritory as LicensedTerritory,
  )

  const route = useRoute()
  const { navigateBack, navigateToLocalized } = useRouterUtils()

  const chargeTotal = computed(() => {
    const priceValue = toValue(price)

    if (!priceValue) return
    const total = isPriceTransparencyEnabled ? priceValue.grossTotal : priceValue.chargeTotal

    return new Money(total)
  })

  const showFlyOut = computed(() => !!toValue(withFlyOut) && (chargeTotal.value?.value ?? 0) > 0)

  const back = () => {
    if (route.query?.backroute && typeof route.query.backroute === 'string') {
      return navigateToLocalized({ path: route.query.backroute }, { replace: true })
    }

    navigateBack()
  }

  return { back, chargeTotal, showFlyOut }
}
